import { createSelector } from '@ngrx/store';

import { getPaymentState } from '../../payment/selectors/getPaymentState';
import { getCurrentLocationNo } from '../../currentLocation/selectors/getCurrentLocationNo';

export const getLocationRedemptionRate = createSelector(getPaymentState, getCurrentLocationNo, (paymentState, locationNo) =>
    paymentState?.redemptionRates.rates.find((rate) => rate.location === locationNo),
);
